import { Switch } from '@factorialco/f0-react/dist/experimental'

import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import useUpsertCompensationSetting from 'modules/compensations/hooks/useUpsertCompensationSetting'

const WorkedHoursTransferSetting = ({
  companyId,
  pendingCompensationsAlertDay,
  enabled,
  canEnable,
}: {
  companyId: string
  pendingCompensationsAlertDay: number
  enabled: boolean
  canEnable: boolean
}) => {
  const [tooltipOpen, toggleTooltip] = useToggle(false)
  const { upsert, loading } = useUpsertCompensationSetting()
  const toggleDisabled = loading || (!enabled && !canEnable)

  const handleToggle = async (nextValue: boolean) => {
    if (!enabled && !canEnable) {
      return
    }

    const handled = handleResult(
      await upsert({
        companyId,
        pendingCompensationsAlertDay,
        workedHoursTransferEnabled: nextValue,
      }),
      () => {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('common.save_error'),
        })
      }
    )

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
    }
  }

  return (
    <Box
      flexDirection="column"
      gap="s16"
      background="grey200"
      padding="s24"
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{ all: 'abs008' }}
    >
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" gap="s16">
        <Box flexDirection="column" gap="s8">
          <Text.Normal weight="semibold" size="200">
            {i18n.t('compensations.settings.time_reimbursements.worked_hours.toggle_title')}
          </Text.Normal>
          <Text.Normal size="100">
            {i18n.t('compensations.settings.time_reimbursements.worked_hours.toggle_description')}
          </Text.Normal>
        </Box>
        <Switch checked={enabled} disabled={toggleDisabled} onCheckedChange={handleToggle} />
      </Box>
      {enabled && (
        <Box flexDirection="column" gap="s8">
          <Box flexDirection="row" gap="s4" alignItems="center">
            <Text.Normal weight="semibold" size="100">
              {i18n.t('compensations.settings.time_reimbursements.worked_hours.payroll_concept')}
            </Text.Normal>
            <Tooltip.Alt
              attachment="bottom center"
              open={tooltipOpen}
              toggle={toggleTooltip}
              label={i18n.t(
                'compensations.settings.time_reimbursements.worked_hours.payroll_concept_tooltip'
              )}
            >
              <Icon.Medium icon="info-circle-line" />
            </Tooltip.Alt>
          </Box>
          <Box
            background="grey000White"
            padding="s12"
            border={{
              all: {
                color: 'grey400',
                width: 's1',
                style: 'solid',
              },
            }}
            borderRadius={{ all: 'abs008' }}
          >
            <Text.Normal>
              {i18n.t('compensations.settings.time_reimbursements.worked_hours.title')}
            </Text.Normal>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default WorkedHoursTransferSetting
